import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_GENERATE_COLLECTION_DATA_BEGIN,
  COLLECTIONS_GENERATE_COLLECTION_DATA_SUCCESS,
  COLLECTIONS_GENERATE_COLLECTION_DATA_FAILURE,
  COLLECTIONS_GENERATE_COLLECTION_DATA_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function generateCollectionData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_GENERATE_COLLECTION_DATA_BEGIN,
    });
    const { projectId, collectionName, version, body } = args;
    const updatedCollectionName = collectionName.trim().replace(/\s+/g, '_');
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${updatedCollectionName}/import-json`,
        body,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_GENERATE_COLLECTION_DATA_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created data', {
            uuid: res.data.uuid,
            collectionName: res.data.collectionName,
          });
          toast.success('Data Created Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_GENERATE_COLLECTION_DATA_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create data for ', { collectionName });
          toast.error(`Failed to create data for ${collectionName}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGenerateCollectionDataError() {
  return {
    type: COLLECTIONS_GENERATE_COLLECTION_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_GENERATE_COLLECTION_DATA_BEGIN:
      return {
        ...state,
        generateCollectionDataPending: true,
        generateCollectionDataError: null,
      };

    case COLLECTIONS_GENERATE_COLLECTION_DATA_SUCCESS:
      return {
        ...state,
        generateCollectionDataPending: false,
        generateCollectionDataError: null,
      };

    case COLLECTIONS_GENERATE_COLLECTION_DATA_FAILURE:
      return {
        ...state,
        generateCollectionDataPending: false,
        generateCollectionDataError: action.data.error,
      };

    case COLLECTIONS_GENERATE_COLLECTION_DATA_DISMISS_ERROR:
      return {
        ...state,
        generateCollectionDataError: null,
      };

    default:
      return state;
  }
}
